
import { computed, defineComponent, ref } from 'vue'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import { useMetaDiscountDiscountables } from '../../composables/meta-discount/useMetaDiscountDiscountables'
import CFileDownload from '../CFileDownload.vue'
import { useContext } from '../../../../../application/composables/useContext'

export default defineComponent({
  name: 'CUploadedMetaDiscountsAssociations',
  components: { CFileDownload },
  setup() {
    const { discountables, downloadDiscountables } = useMetaDiscountDiscountables()
    const isLoading = ref(false)
    const { isRetail } = useContext()
    const i18n = useI18nForVue2()

    return {
      placeholder: computed(() =>
        discountables.count.value === null
          ? `${isRetail.value ? i18n.t('ctx.discount.detail.download-products') : i18n.t('ctx.discount.detail.download-offers')}`
          : `${discountables.count.value} ${isRetail.value ? i18n.t('ctx.discount.detail.imported-products') : i18n.t('ctx.discount.detail.imported-offers')}`,
      ),

      downloadDiscountables: async () => {
        isLoading.value = true
        await downloadDiscountables()
        isLoading.value = false
      },
      isLoading,
    }
  },
})
